import React from 'react';
import { Icon } from 'antd';
import { BibliographicReference } from '../../../../../components/BibliographicReference/BibliographicReference';
import { Button } from '../../../../../components/Button';
import { Modal } from '../../../../../components/Modal';

export const Bibliographic = ({ options }) => {
  const close = () => options.setShowBibliografy(false);

  const footer = [
    <Button key="btn-1" type={'primary'} onClick={close}>
      <Icon type="close" />
      Fechar
    </Button>
  ];

  return (
    <Modal
      maskClosable={true}
      title="Referência Bibliográfica"
      visible={options.showBibliografy}
      onCancel={close}
      onOk={close}
      footer={footer}
      maskStyle={{ background: 'rgba(0,0,0,.2)' }}>
      <BibliographicReference citation={options.bibliografyItem} />
    </Modal>
  );
};
